<template>
  <div class="-block">
    <div class="-title">
      <vs-icon icon="filter_list"></vs-icon>
      <span>เงื่อนไข</span>
    </div>

    <!-- <div class="-selector-container">
      <div class="-selectors">
        <vs-button class="btnx" type="filled">
          ปีการศึกษา
          <span v-if="academicPeriodSelection">
            : {{ academicPeriodSelection.label }} 
          </span>
        </vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <template v-for="(option) in academicPeriodOptions">
              <vs-dropdown-item
                :key="option.id"
                @click="onAcademicPeriodSelection(option)"
              >
                {{ option.periodCode }} -> {{ option.year }}
              </vs-dropdown-item>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div> -->

    <div class="-selector-container">
      <div class="-selectors">
        <vs-button class="btnx" type="filled">
          ระดับการศึกษา
          <span v-if="degreeSelection">
            : {{ degreeSelection.label }} 
          </span>
        </vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <template v-for="(option) in degreeOptions">
              <vs-dropdown-item
                :key="option.id"
                @click="onDegreeSelection(option)"
              >
                {{ option.label }}
              </vs-dropdown-item>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <div class="-selector-container">
      <div class="-selectors">
        <vs-button class="btnx" type="filled">
          กลุ่มวิชา
          <span v-if="subjectGroupSelection !== null">
            : {{ subjectGroupSelection.label }} 
          </span>
        </vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <template v-for="(option) in subjectGroupOptions">
              <vs-dropdown-item
                :key="option.id"
                @click="onSubjectGroupSelection(option)"
                :disabled="option.unselectable"
              >
                {{ option.label }}
              </vs-dropdown-item>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <div class="-selector-container">
      <div class="-selectors">
        <vs-button class="btnx" type="filled">
          ชื่อวิชา
          <span v-if="subjectSelection !== null">
            : {{ subjectSelection.label }} 
          </span>
        </vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <template v-for="(option) in subjectOptions">
              <vs-dropdown-item
                :key="option.id"
                @click="onSubjectSelection(option)"
                :disabled="option.unselectable"
              >
                {{ option.label }}
              </vs-dropdown-item>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <div class="-selector-container">
      <div class="-selectors">
        <vs-button class="btnx" type="filled">
          อาจารย์
          <span v-if="teacherSelection !== null">
            : {{ teacherSelection.label }} 
          </span>
        </vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>
            <template v-for="(option) in teacherFilterList">
              <vs-dropdown-item
                :key="option.id"
                @click="onTeacherSelection(option)"
                :disabled="option.unselectable"
              >
                {{ option.label }}
              </vs-dropdown-item>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
// import InputBox from "@/components/common-ui/forms/input-box/index.vue";
import { state } from "../data";
import { loadSubjects, loadTeacherList, /* loadCourseOutlineByFilter */ } from "../data/data-loader";

export default {
  data() {
    return {
      isSelectionListActive: false,
      allFilterSelections: state.local.filterSelection,
      form: state.local.form,
      options: {
        subjects: state.local.selectorOptions.subject
      }
    }
  },
  components: {
    // InputBox
  },
  computed: {
    academicPeriodOptions() {
      return state.store.CommonData.AcademicPeriod.academicPeriods;
    },
    academicPeriodSelection() {
      return state.local.filterSelection.academicPeriod;
    },
    degreeOptions() {
      return state.store.CommonData.Degree.degrees;
    },
    degreeSelection() {
      return state.local.filterSelection.degree;
    },
    subjectGroupOptions() {
      const degree = state.local.filterSelection.degree
      if (degree) {
        const allSubjectGroups = state.store.CommonData.SubjectGroup.subjectGroups;
        const filterSubjectGroupsByDegree = allSubjectGroups
          .filter(item => item.degree.id === degree.id);

        if (filterSubjectGroupsByDegree.length > 0) {
          return filterSubjectGroupsByDegree;
        }
        return [ { id: 0, label: "ไม่มีกลุ่มวิชา", unselectable: true }];
      }
      return state.store.CommonData.SubjectGroup.subjectGroups;
    },
    subjectGroupSelection() {
      return state.local.filterSelection.subjectGroup;
    },
    subjectOptions() {
      if (state.local.selectorOptions.subject.length > 0) {
        return state.local.selectorOptions.subject.map(item => {
          return { id: item.id, label: item.code + ' ' + item.nameLocal, subjectCode: item.code };
        })
      }
      return [ { id: 0, label: "ไม่มีกลุ่มวิชา", unselectable: true }];
    },
    subjectSelection() {
      return state.local.filterSelection.subject;
    },
    teacherFilterList() {
      if (state.store.Profile.teachers.length > 0) {
        return state.store.Profile.teachers
          .map(item => {
            return {
              id: item.id,
              label: item.code + ' ' + item.firstNameLocal + ' ' + item.lastNameLocal,
              teacherCode: item.code
            };
          })
      }
      return [ { id: 0, label: "ไม่มีอาจารย์ในวิชานี้", unselectable: true }];
    },
    teacherSelection() {
      return state.local.filterSelection.teacher;
    },
  },
  watch: {
    // academicPeriodSelection(val) {
    //   this.form.filter.academicPeriodId
    //     = val.id;
    //   this.form.filter.periodCode
    //     = val.code;
    // },
    degreeSelection(val) {
      this.form.filter.degreeId
        = val.id;
    },
    subjectGroupSelection(val) {
      this.form.filter.subjectGroupId
        = val.id;
    },
    subjectSelection(val) {
      this.form.filter.subjectId
        = val.id;
    },
    teacherSelection(val) {
      this.form.filter.teacherId
        = val.id;
    }
  },
  methods: {
    onAcademicPeriodSelection(option) {
      state.local.filterSelection.academicPeriod = option;

      // Set label for selected academic period.
      // DISABLED: Use GraphQL alias and fragment instead.
      // state.local.filterSelection.academicPeriod.label 
      //   = `${ option.periodCode } -> ${ option.year }`;
    },
    onDegreeSelection(option) {
      state.local.filterSelection.degree = option;
      state.local.filterSelection.subjectGroup = {};
    },
    onSubjectGroupSelection(option) {
      state.local.filterSelection.subjectGroup = option;
      loadSubjects(option.id);
      // loadCourseOutlineByFilter(option.id);
    },
    onSubjectSelection(option) {
      state.local.filterSelection.subject = option;
      // Load Teacher
      loadTeacherList();
    },
    onTeacherSelection(option) {
      state.local.filterSelection.teacher = option;
    }
  }
}
</script>

<style lang="scss" scoped>
.-block {
  padding: 20px 20px;
  width: 100%;
  background: #e4ece9;
  display: inline-flex;

  & .-title {
    font-size: 1.2rem;
    height: 38px !important;
    margin-right: 20px;
    display: inline-flex;
    align-items: center;

    & i {
      font-size: 1.4rem;
      margin-right: 8px;
    }

    & span {
      line-height: 38px;
    }
  }

  & .-selector-container {
    display: inline-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: relative;

    & .-selectors {
      display: inline-flex;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-right: 10px !important;
      margin-bottom: 10px !important;
      position: relative;

      & button {
        margin: 0px !important;
        background: #009688 !important;
        border-radius: 5px;

        &.btnx {
          height: 38px !important;  
          border-radius: 5px 0px 0px 5px;
          padding-left: 1rem;
        }

        &.btn-drop {
          border-radius: 0px 5px 5px 0px;
          border-left: 1px solid rgba(255, 255, 255,.2);
        }
      }
    }

    & .--selection-list {
      position: absolute;
      top: 93px;
      right: 19px;
      width: calc(100% - 30px);
      transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 0.2s;

      & ul {
        box-shadow: 0px 1px 2px 0px rgba(60, 64, 67, 0.1), 0px 1px 3px 1px rgba(60, 64, 67, 0.15);
        border-radius: 0 0 8px 8px;
        overflow: hidden;

        & li {
          width: 100%;
          background: white;
          padding: 8px 10px;
          min-width: 300px;
          border-bottom: 1px solid #d8d8d8;
        }
      }
    }
  }
}
</style>
